import styled from 'styled-components';

const CollapseWrapperInner = styled.div`
    width: 100%;
`;

export default CollapseWrapperInner;
